var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlay2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM12.6131 21.1232C12.8175 21.2633 13.0219 21.3333 13.2263 21.3333C13.388 21.3333 13.5497 21.2895 13.7452 21.2364C13.7968 21.2225 13.8507 21.2078 13.9075 21.1932L20.7202 17.1297C21.129 16.9195 21.3333 16.4992 21.3333 16.0088C21.3333 15.5183 21.129 15.098 20.7202 14.8878L13.9075 10.8243C13.4988 10.6141 13.0219 10.6141 12.6131 10.8243C12.2044 11.0345 12 11.4548 12 11.9453V20.0022C12 20.4926 12.2044 20.913 12.6131 21.1232Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlay2);
export default ForwardRef;